<div class="canary-check" id="classic-admin">
    <h1>Health Check</h1>

    <p>
        Status: ✅
        <strong>Healthy</strong>
    </p>

    <ul>
        <li>App : Oversight</li>
        <li>App State: Working</li>
    </ul>
</div>
